<template>
	<div class="page">
		<gc-header headerData="deviceGroupDetails"></gc-header>
		<div class="page-main">
			<gc-group-detail :data="basicInfoData"></gc-group-detail>
			<el-radio-group v-model="tabIndex" size="medium">
				<el-radio-button :label="0">关联设备</el-radio-button>
				<el-radio-button :label="1">操作日志</el-radio-button>
			</el-radio-group>
			<div class="table-content" v-loading="loading">
				<gc-table
					border
					:showPage="true"
					:columns="tabIndex === 0 ? deviceColumns : operateLogColumns"
					:table-data="tableData"
					:total="pagination.total"
					:pageSize="pagination.pageSize"
					gloabSortDisable
					paginationLayout="prev, next, jumper"
					@current-page-change="handleCurrentPageChange"
				></gc-table>
			</div>
		</div>
	</div>
</template>

<script>
import {
	apiGetDeviceGroupDetails,
	apiGetModulePageList,
	apiGetOperateLogPageList,
} from '@/apis/communicationModelManage.api'
export default {
	name: 'deviceGroupDetails',
	data() {
		return {
			deviceGroupId: this.$route.query.id,
			deviceGroupDetails: {},
			tabIndex: 0,
			deviceColumns: [
				{
					key: 'deviceNo',
					name: '设备通讯编号',
					tooltip: true,
				},
				{
					key: 'imei',
					name: 'IMEI',
				},
				{
					key: 'deviceTypeName',
					name: '设备类型',
				},
				{
					key: 'manufacturerName',
					name: '厂商',
				},
				{
					key: 'deviceGroupName',
					name: '设备组名称',
					tooltip: true,
				},
				{
					key: 'statusName',
					name: '注册状态',
				},
				{
					key: 'oprate',
					name: '操作',
					sortDisable: true,
					width: 180,
					render: (h, row) => {
						return h('div', null, [
							h(
								'el-button',
								{
									props: { type: 'text', size: 'medium' },
									on: {
										click: () => this.handleImeiModuleDetails(row),
									},
								},
								'详情',
							),
						])
					},
				},
			],
			operateLogColumns: [
				{ key: 'operationType', name: '操作类型' },
				{ key: 'operatorName', name: '操作人' },
				{ key: 'operationTime', name: '操作时间' },
				{ key: 'operationInfo', name: '操作后信息', tooltip: true },
			],
			loading: false,
			pagination: {
				currentPage: 1,
				pageSize: 20,
				total: 0,
			},
			tableData: [],
		}
	},
	computed: {
		basicInfoData() {
			const d = this.deviceGroupDetails
			return {
				title: '设备组信息',
				row: 4,
				list: [
					{
						key: 'deviceGroupName',
						label: '设备组名称',
						value: d.deviceGroupName,
					},
					{
						key: 'manufacturerName',
						label: '厂商',
						value: d.manufacturerName,
					},
					{
						key: 'deviceTypeName',
						label: '设备类型',
						value: d.deviceTypeName,
					},
					{
						key: 'status',
						label: '状态',
						value: d.status === 1 ? '启用' : '禁用',
					},
					{
						key: 'createStaffName',
						label: '创建人',
						value: d.createStaffName,
					},
					{
						key: 'createdTime',
						label: '创建时间',
						value: d.createdTime,
					},
					{
						key: 'remarks',
						label: '备注',
						value: d.remarks,
						col: 4,
					},
				],
			}
		},

		manufacturerId() {
			return this.$store.getters.userInfo.manufacturerId
		},
	},

	created() {
		this.queryDeviceGroupDetails()
		this.queryTableDataPageList()
	},

	methods: {
		async queryDeviceGroupDetails() {
			const data = await apiGetDeviceGroupDetails(this.deviceGroupId)
			this.deviceGroupDetails = data
		},

		async queryTableDataPageList() {
			this.loading = true
			const API = this.tabIndex === 0 ? apiGetModulePageList : apiGetOperateLogPageList
			const searchParams = {
				current: this.pagination.currentPage,
				size: this.pagination.pageSize,
				deviceGroupId: this.deviceGroupId,
				manufacturerId: this.manufacturerId,
				logType: '2',
				relatedId: this.deviceGroupId,
			}
			try {
				const { records = [], total } = await API(searchParams)
				this.tableData = records
				this.pagination.total = total
			} finally {
				this.loading = false
			}
		},

		handleCurrentPageChange(current) {
			this.pagination.currentPage = current
			this.queryTableDataPageList()
		},

		async handleImeiModuleDetails(rowItem) {
			this.$router.push({
				path: '/communication-model-manage/module-manage/details',
				query: { id: rowItem.id, uuid: rowItem.uuid },
			})
		},
	},

	watch: {
		tabIndex() {
			this.tableData = []
			this.pagination.currentPage = 1
			this.queryTableDataPageList()
		},
	},
}
</script>
<style lang="scss" scoped>
@import '../../run-manage/runLayout.scss';
.page-main {
	flex-direction: column;
	padding: 0 20px;
	.table-content {
		flex: 1;
		height: 0;
		padding: 12px 0;
	}
}
</style>
